import { supabase, DASHBOARD_LABEL } from './supabase'

const STORAGE_KEY = 'recon.session'
const DEFAULT_USER = 'admin@wowvegas.com'

interface Session {
  password: string
  user: string
  since: number
}

export function readSession(): Session | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as Session) : null
  } catch {
    return null
  }
}

export function writeSession(password: string) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ password, user: DEFAULT_USER, since: Date.now() }),
  )
}

export function clearSession() {
  localStorage.removeItem(STORAGE_KEY)
}

export async function verifyPassword(password: string): Promise<boolean> {
  const { data, error } = await supabase.rpc('recon_verify_dashboard_password', {
    p_label: DASHBOARD_LABEL,
    p_password: password,
  })
  if (error) throw error
  const row = Array.isArray(data) ? data[0] : data
  return Boolean(row?.ok)
}
